import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        当ページ下部の
        <a className={styles.link} href="#contact">
          お問い合わせフォーム
        </a>
        よりご連絡ください。
        <br />
        ※状況に応じて以下の内容に沿ってご入力いただくと、その後のやり取りがスムーズになります。
      </p>
    </div>
    <div>
      <p className={styles.heading}>【転入する生徒がいる場合】</p>
      <ul className={styles.list}>
        <li className={styles.item}>学年</li>
        <li className={styles.item}>追加人数</li>
        <li className={styles.item}>
          追加で購入したいvol.（卒業までに使用するすべてのvol.をご記入ください）
        </li>
        <li className={styles.item}>納品希望日</li>
      </ul>
    </div>
    <div>
      <p className={styles.heading}>【領収書の発行を希望する場合】</p>
      <ul className={styles.list}>
        <li className={styles.item}>学年</li>
        <li className={styles.item}>お渡し期日</li>
      </ul>
    </div>
  </div>
);

export const BILLING_INQUIRY_FAQ: FaqCategoryItem = {
  id: "billing-inquiry-faq",
  question: "人数変更や請求について問い合わせたい",
  Answer,
};
